const supportedBrands = ['atc', 'kbb', 'ford'];
const params = {
  atc: {
    prod: {
      google: {
        gtmCode: 'GTM-KXC7LXT'
      },
      segment: {
        writeKey: 'itSj8TFoYusObVRJCrCgf22y0epCwZU9'
      }
    },
    qa: {
      google: {
        gtmCode: 'GTM-K4R3978'
      },
      segment: {
        writeKey: 'evI1Hvd5MpGHB1vXUz01XJkWZLFDD1t5'
      }
    }
  },
  kbb: {
    prod: {
      google: {
        gtmCode: 'GTM-TK7B6ZX'
      }
    },
    qa: {
      google: {
        gtmCode: 'GTM-MW9FSRH'
      }
    }
  },
  ford: {
    prod: {
      google: {
        gtmCode: 'GTM-NBGPWJ8'
      },
      pixall: {
        page: {
          dealerCode: 'atfordcpo'
        }
      }
    },
    qa: {
      google: {
        gtmCode: 'GTM-M5Z3QM7'
      }
    }
  },
  myWallet: {
    prod: {
      google: {
        gtmCode: 'GTM-KHW4NP9',
        dataLayerName: 'myWallet'
      }
    },
    qa: {
      google: {
        gtmCode: 'GTM-WGS2WWN',
        dataLayerName: 'myWallet'
      }
    }
  }
};
export default {
  supportedBrands,
  params
};